/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EditArea/view.blocks to change it.
import QuestionChooser from './QuestionChooser/index'
import QuestionFields from './QuestionFields/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EditArea({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea"
  
}) {
  return (<React.Fragment
>
<QuestionChooser
  viewPath={`${viewPath}/QuestionChooser`}
/>
<QuestionFields
  viewPath={`${viewPath}/QuestionFields`}
/>
{children}
</React.Fragment>)
}